export default "__VITE_ASSET__Bch9_5zy__"